(() => {
  function init(scope = document) {
    scope.querySelectorAll('.s26-page-search:not([data-scope-ready])').forEach(form => {
      form.dataset.scopeReady = 'true';
      const select = form.querySelector('[name="type"]');
      const input = form.querySelector('[name="q"]');
      const label = form.querySelector('label[for="PageSearch"]');
      const introduction = form.closest('.s26-search-page')?.querySelector('[data-search-introduction]');
      if (!select || !input || !label) return;
      const update = () => {
        const guides = select.value === 'article', products = select.value === 'product';
        label.textContent = guides ? 'Topic or question' : products ? 'Product name, brand or SKU' : 'Product, topic or question';
        input.placeholder = guides ? 'For example, cat hydration…' : products ? 'For example, 4CYTE…' : 'For example, joint care…';
        if (introduction) introduction.textContent = guides ? 'Find reading about everyday pet care, health questions and choosing products.' : products ? introduction.dataset.productIntroduction : 'Search products, pet care guides and store information in one place.';
      };
      select.addEventListener('change', update);
      update();
    });
    scope.querySelectorAll('[data-predictive-search]:not([data-search-ready])').forEach(form => {
      const input = form.querySelector('[data-search-input]');
      const panel = form.querySelector('[data-search-panel]');
      const status = form.querySelector('[data-search-status]');
      const cache = new Map();
      let timer, request, version = 0, dismissed = false;
      form.dataset.searchReady = 'true';
      const mobileSearch = matchMedia('(max-width: 760px)');
      const desktopPlaceholder = input.placeholder;
      const updatePlaceholder = () => { input.placeholder = mobileSearch.matches ? 'Brand or ingredient' : desktopPlaceholder; };
      mobileSearch.addEventListener('change', updatePlaceholder); updatePlaceholder();
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-haspopup', 'listbox');
      input.setAttribute('aria-controls', 'SuggestedProducts');
      input.setAttribute('aria-expanded', 'false');
      const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); };
      const options = () => [...panel.querySelectorAll('[data-search-option]')];
      const show = markup => {
        if (!form.contains(document.activeElement)) return;
        panel.innerHTML = markup;
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        const count = options().length;
        status.textContent = count ? `${count} search suggestion${count === 1 ? '' : 's'}. Use the down arrow to browse.` : 'No suggestions. Search the full catalogue or guides.';
      };
      async function suggest() {
        const term = input.value.trim();
        if (term.length < 2) { close(); return; }
        const ownVersion = ++version;
        request?.abort();
        if (cache.has(term)) { show(cache.get(term)); return; }
        request = new AbortController();
        status.textContent = 'Searching products and guides…';
        try {
          const url = new URL(form.dataset.suggestUrl, location.origin);
          url.search = new URLSearchParams({q: term, section_id: 'predictive-search', 'resources[type]': 'product,article', 'resources[limit]': '4', 'resources[limit_scope]': 'each', 'resources[options][unavailable_products]': 'show'}).toString();
          const response = await fetch(url, {signal: request.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-predictive-content]');
          if (!html) throw new Error('No search section');
          if (ownVersion !== version || input.value.trim() !== term) return;
          if (cache.size >= 20) cache.delete(cache.keys().next().value);
          cache.set(term, html.innerHTML);
          show(html.innerHTML);
        } catch (error) {
          if (error.name === 'AbortError' || ownVersion !== version) return;
          close(); status.textContent = 'Suggestions are unavailable. Select Search to see full results.';
        }
      }
      input.addEventListener('input', event => {
        dismissed = false; clearTimeout(timer); request?.abort(); ++version; close();
        if (!event.isComposing) timer = setTimeout(suggest, 240);
      });
      input.addEventListener('compositionend', () => { clearTimeout(timer); timer = setTimeout(suggest, 240); });
      input.addEventListener('focus', () => { if (!dismissed && cache.has(input.value.trim())) show(cache.get(input.value.trim())); });
      form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(); });
      form.addEventListener('keydown', event => {
        if (event.key === 'Escape') { dismissed = true; ++version; clearTimeout(timer); request?.abort(); close(); input.focus(); return; }
        if (panel.hidden || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        const links = options();
        if (!links.length) return;
        event.preventDefault();
        const current = links.indexOf(document.activeElement);
        const next = current < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1) : (current + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links.forEach((link, index) => link.setAttribute('aria-selected', String(index === next)));
        input.setAttribute('aria-activedescendant', links[next].id);
        links[next].focus();
      });
      form.addEventListener('submit', event => { const scope = form.querySelector('input[name="type"]'); if (scope) scope.value = event.submitter?.hasAttribute('data-search-products') ? 'product' : 'product,article,page'; request?.abort(); clearTimeout(timer); close(); });
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) close(); });
    });
    scope.querySelectorAll('[data-shopping-cart]:not([data-shopping-ready])').forEach(form => {
      form.dataset.shoppingReady = 'true';
      const link = form.querySelector('[data-cart-inquiry]');
      const hint = form.querySelector('[data-cart-update-hint]');
      if (!link || !hint) return;
      const quantities = [...form.querySelectorAll('input[name="updates[]"]')];
      const dirty = () => quantities.some(input => input.value !== input.defaultValue);
      form.addEventListener('input', () => { hint.hidden = !dirty(); link.setAttribute('aria-disabled', String(dirty())); });
      link.addEventListener('click', event => { if (dirty()) { event.preventDefault(); hint.hidden = false; form.querySelector('[name="update"]').focus(); } });
    });
    const message = scope.querySelector('[data-contact-message]');
    if (message && !message.value.trim()) {
      const items = new URLSearchParams(location.search).get('items');
      if (items) message.value = 'Please confirm availability and ordering for these packs:\n\n' + items.slice(0, 8000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
